import { createSlice } from "@reduxjs/toolkit"


var data=[]


if (localStorage.getItem("expenses") !== null && localStorage.getItem("expenses") !== undefined && localStorage.getItem("expenses") !== "") {

    data = JSON.parse(localStorage.getItem("expenses"))

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        getexpenses: (state, action) => {
            localStorage.setItem("expenses", JSON.stringify(action.payload.data))
            state = action.payload.data
            return state
        
          
        },

    },

})

export const { getexpenses } = Insider.actions;
export default Insider.reducer;